// extracted by mini-css-extract-plugin
export default {"header":"NewsHeader_header__xzrP7"};